import React, { useState, RefObject, forwardRef, useEffect, useRef, createContext } from 'react';
import { WindowContextClass } from './windows.context';

export const WindowsContext = createContext<WindowContextClass>(new WindowContextClass({}));

type Props = {
  minLayer?: number
};

export const WindowsContextProvider = forwardRef((
  { minLayer, ...props}: React.AllHTMLAttributes<HTMLDivElement> & Props,
  containerRef: RefObject<HTMLDivElement | null>,
) => {
  if (!containerRef) {
    containerRef = useRef<HTMLDivElement | null>(null);
  }

  const [ context ] = useState<WindowContextClass>(new WindowContextClass({ minLayer }));

  useEffect(() => {
    if (containerRef.current) {
      context.container = containerRef.current;
      return () => {
        context.container = null;
      }
    }
  }, [containerRef.current]);

  return (
    <WindowsContext.Provider value={context}>
      <div ref={containerRef} {...props} />
    </WindowsContext.Provider>
  );
});